import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class InsuranceRiskAssessmentModal extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#insurance-risk-assessment-form-modal',
			triggerSelectors: ['.js-insurance-risk-assessment-trigger'],
			editTriggerSelectors: ['.js-insurance-risk-assessment-edit-trigger'],
			stepsEndpointAttr: 'insurance-risk-assessment-steps-endpoint',
			submitEndpointAttr: 'insurance-risk-assessment-submit-endpoint',
			wrapperSelector: '.p-venue-registration-insurance-info',
			sectionWrapperSelector: '.p-venue-registration-insurance-info-wrapper',
			logPrefix: 'InsuranceRiskAssessmentModal'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			exitButtonLabel: 'Save and exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(InsuranceRiskAssessmentModal);

export default InsuranceRiskAssessmentModal;
